export class ApplicationConfigMocks {
  public PLATFORM_ID = 'server';

  get(value: string) {
    return '';
  }

  get platformId() {
    return this.PLATFORM_ID;
  }

  get onServer() {
    return this.platformId === 'server';
  }

  get onBrowser() {
    return !this.onServer;
  }
}
